import React, { useState } from 'react'
import { Form, Input, Row, Col, Divider, DatePicker, Button, notification, Upload, Alert, Card } from 'antd'
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, SelectOutlined } from '@ant-design/icons';
import { useParams , useHistory } from 'react-router-dom'
import AppService from 'services/AppService';
import { useEffect } from 'react';
import moment from 'moment'
import { connect } from 'react-redux';
import { motion } from "framer-motion"
import { FaLinkedinIn } from 'react-icons/fa'
import {
    showAuthMessage,
    hideAuthMessage,
    getProfile,
    setLogo,
    setLogoActive
} from 'redux/actions/Auth';
import Flex from 'components/shared-components/Flex';
import { API_BASE_URL } from 'configs/AppConfig';
import EducationAddFields from '../jobrole/components/EducationAddFields';
import ExperienceAddFields from '../jobrole/components/ExperienceAddFields';

function EditAddress(props) {
    const {  showAuthMessage, hideAuthMessage, showMessage, getProfile } = props
    const [filelist, setFilelist] = useState([])
    const [filelist2, setFilelist2] = useState([])
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const { id } = useParams()
    const history = useHistory();

    const handleFinish = (values) => {
        setLoading(true)

        const formdata = new FormData()
        formdata.append('address', values.address ? values.address : '')
        formdata.append('city', values.city ? values.city : '')
        formdata.append('pincode', values.pincode ? values.pincode : '')
        formdata.append('state', values.state ? values.state : '')
        AppService.updateProfile({data: formdata, type: 'address'}).then(resp => {
            notification.success({
                message: resp
            })
            getProfile()
            fetchProfile()
            setLoading(false)
        }).catch(e => {
            showAuthMessage(e.response.data)
            setLoading(false)
        })

    }
    // function disabledDate(current) {
    //     // Can not select days before today and today
    //     return current && current.valueOf() > moment("01:12:2002");
    //   }
    const fetchProfile = () =>{
        AppService.fetchProfile().then(resp => {
            // console.log(resp)
            const { birthDate, education, experienceDetails, resume, profileImg, ...rest } = resp
            resume && setFilelist(
                [
                    {
                        uid: '-1',
                        name: `${resume}`,
                        status: 'done',

                    }
                ]
            )
            profileImg && setFilelist2(
                [
                    {
                        uid: '-1',
                        name: `${profileImg}`,
                        status: 'done',
                        url: `${API_BASE_URL}/image/profile/${profileImg}`,
                    }
                ]
            )
            form.setFieldsValue({
                ...rest,
                birthDate: moment(birthDate),
                education: education.map(e => {
                    return {
                        ...e,
                        joiningDate: moment(e.joiningDate),
                        passoutDate: moment(e.passoutDate)
                    }
                }),
                experienceDetails: experienceDetails.map(e => {
                    return {
                        ...e,
                        joiningDate: moment(e.joiningDate),
                        relievingDate: moment(e.relievingDate)
                    }
                })
            })
           
        }).catch(e => notification.error({
            message: 'Oops! Unable to fetch Profile. '
        }))
    }

    useEffect(() => {
        props.setLogo("/img/logo.png")
        props.setLogoActive(true)
        fetchProfile()
       
    }, [])

    useEffect(() => {
        if (showMessage) {
            setTimeout(() => {
                hideAuthMessage()
            }, 3000)
        }
    })
    return (
        <div className='main'>
        <div className='container'>
           <Row>
    <Col span={24}>
        <Button 
            style={{backgroundColor:'#1677ff',color:'#fff', marginBottom: '20px'}} 
            icon={<SelectOutlined className="mb-3" size={20} />} 
            onClick={() => history.push("/app/profile/edit")}
            >
            Go Back
        </Button>
    </Col>
</Row>
  <Card style={{padding:"20px 2%"}}>
  <div className='settings-page-heading'>
    <h1>
        Address Details
    </h1>
  </div>
  
  <Divider></Divider>
  <Form
                    form={form}
                    onFinish={handleFinish}
                    layout='vertical'
                    className='mt-5'>
                    <Row gutter={8}>
                        <Col md={12} sm={24} xs={24} >
                            <Form.Item name="address" label="Address"  >
                                <Input placeholder='Address'>
                                </Input>
                            </Form.Item>

                        </Col>
                        <Col md={4} sm={12} xs={24}>
                            <Form.Item name="state" label="State"  >
                                <Input placeholder='State'>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col md={4} sm={12} xs={24}>
                            <Form.Item name="city" label="City"  >
                                <Input placeholder='City'>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col md={4} sm={12} xs={24}>
                            <Form.Item name="pincode" label="PinCode" rules={[() => ({
                                validator(rule, value) {

                                    const reg = /^[0-9]*$/;
                                    if (reg.test(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject("Pincode must be digit ")
                                },
                            }),]}>
                                <Input type="tel" placeholder='Pincode' maxLength={10}>
                                </Input>
                            </Form.Item>
                        </Col>
                            <Col span={24}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                    Update
                                </Button>
                            </Col>
                    </Row>
                </Form>
               </Card>
           </div>
        </div>
    )
}
const mapStateToProps = ({ auth }) => {
    const { message, showMessage } = auth
    return { message, showMessage }
}
const mapDispatchToProps = {
    showAuthMessage,
    hideAuthMessage,
    getProfile,
    setLogo,
    setLogoActive
}


export default connect(mapStateToProps, mapDispatchToProps)(EditAddress)
